<template>
	<nav class="navigation-bar-mobile">
		<router-link to="/" class="">
			<img :src="sosLogo" class="company-logo" @click="clickCompanyLogo" />
		</router-link>
		<img
			v-if="!isBurgerMenuOpen"
			:src="iconMenuWhite"
			@click="toggleBurgerMenu"
		/>
		<img v-else :src="iconMenuOpenWhite" @click="toggleBurgerMenu" />
		<ul
			v-if="isBurgerMenuOpen && !showSecondLevel"
			class="navigation-list-first-level"
		>
			<li>
				<div
					class="navigation-entry-with-second-level"
					@click="openSecondLevel"
				>
					<span>System of Self-preservation®</span>
					<img :src="iconArrowForwardWhite" />
				</div>
			</li>
			<li v-for="(entry, index) in entryListWithoutDropdwon" :key="index">
				<router-link-component
					:pathname="entry.pathname"
					:linkText="entry.linkText"
				/>
			</li>
			<li>
				<language-selector-entry-mobile />
			</li>
		</ul>
		<div
			v-if="isBurgerMenuOpen && showSecondLevel"
			class="navigation-list-second-level"
		>
			<img :src="iconArrowBackWhite" @click="closeSecondLevel" />
			<ul>
				<li v-for="(entry, index) in entryListForDropdwon" :key="index">
					<router-link-component
						:pathname="entry.pathname"
						:linkText="entry.linkText"
					/>
				</li>
			</ul>
		</div>
	</nav>
</template>

<script>
import Logo from '@/assets/logo.png'
import IconExpandDown from '@/assets/icons/expand_down.svg'
import IconMenuWhite from '@/assets/icons/menu_white.svg'
import IconMenuOpenWhite from '@/assets/icons/menu_open_white.svg'
import IconArrowForwardWhite from '@/assets/icons/arrow_forward_white.svg'
import IconArrowBackWhite from '@/assets/icons/arrow_back_white.svg'
import RouterLinkComponent from '@/components/RouterLinkComponent.vue'
import LanguageSelectorEntryMobile from './LanguageSelectorEntryMobile.vue'

export default {
	name: 'Navigation',
	components: {
		RouterLinkComponent,
		LanguageSelectorEntryMobile
	},
	data() {
		return {
			sosLogo: Logo,
			iconExpandDown: IconExpandDown,
			iconMenuWhite: IconMenuWhite,
			iconMenuOpenWhite: IconMenuOpenWhite,
			iconArrowForwardWhite: IconArrowForwardWhite,
			iconArrowBackWhite: IconArrowBackWhite,
			isBurgerMenuOpen: false,
			showSecondLevel: false,
			entryListWithoutDropdwon: [
				{
					pathname: 'Editorial',
					linkText: this.$t('navigation.mainEntries.blog')
				},
				{
					pathname: 'Medien',
					linkText: this.$t('navigation.mainEntries.media')
				},
				{
					pathname: 'Referenzen',
					linkText: this.$t('navigation.mainEntries.references')
				},
				{
					pathname: 'Kontakt',
					linkText: this.$t('navigation.mainEntries.contact')
				}
			],
			entryListForDropdwon: [
				{
					pathname: 'DasSystem',
					linkText: this.$t('navigation.mainEntries.theSystem')
				},
				{
					pathname: 'Aufbau',
					linkText: this.$t('navigation.mainEntries.structure')
				},
				{
					pathname: 'Ausbildungsgrade',
					linkText: this.$t('navigation.mainEntries.trainingContent')
				},
				{
					pathname: 'Ausbilder',
					linkText: this.$t('navigation.mainEntries.trainer')
				}
			]
		}
	},
	methods: {
		toggleBurgerMenu() {
			this.isBurgerMenuOpen = !this.isBurgerMenuOpen
		},
		openSecondLevel() {
			this.showSecondLevel = true
		},
		closeSecondLevel() {
			this.showSecondLevel = false
		},
		clickCompanyLogo() {
			this.closeSecondLevel()
			if (this.isBurgerMenuOpen) {
				this.toggleBurgerMenu()
			}
		}
	},
	watch: {
		$route() {
			if (this.isBurgerMenuOpen) {
				this.toggleBurgerMenu()
			}
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_navigation.json'),
			en: require('@/i18n/en/eng_navigation.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.navigation-bar-mobile {
	background-color: #000;
	font-family: 'Red Hat Display', sans-serif;
	display: flex;
	justify-content: space-between;
	padding: 10px 28px 14px 22px;
	width: 100%;
	position: fixed;
    top: 0;
    z-index: 1;
	cursor: pointer;
}
.company-logo {
	width: 100%;
	max-width: 220px;
}
.navigation-list-first-level {
	list-style-type: none;
	margin: 0;
}
.navigation-list-second-level ul {
	list-style-type: none;
	margin: 0;
	padding: 0;
}
.navigation-list-first-level, .navigation-list-second-level {
    position: absolute;
    top: 90px;
    right: 0;
    background-color: #000;
    width: 100%;
    padding-top: 25px;
	padding-bottom: 15px;
	padding-right: 28px;
}
.navigation-list-first-level > li, .navigation-list-second-level ul > li {
    margin: 20px 0;
	cursor: pointer;
}
.navigation-list-second-level {
	padding: 40px 28px 10px 38px;
	cursor: pointer;
}
.navigation-entry-with-second-level {
	display: flex;
    justify-content: space-between;
    align-items: center;
	cursor: pointer;
}
</style>
